document.addEventListener('DOMContentLoaded', () => {
  console.log('CaSlideshow script loaded');

  const slideshow = document.querySelector('.ca-slideshow');
  if (!slideshow) {
    console.error('CaSlideshow element not found');
    return;
  }

  const slides = document.querySelectorAll('.ca-slide');
  const prevBtn = document.querySelector('.ca-slider-button--prev');
  const nextBtn = document.querySelector('.ca-slider-button--next');
  const dots = document.querySelectorAll('.ca-slider-counter__link--dots');
  const animationType = slideshow.dataset.animation || 'parallax'; // Valore di default
  const speed = parseInt(slideshow.dataset.speed) * 1000 || 5000; // Converti in millisecondi, default 5s
  let currentSlide = 0;
  let isPlaying = slideshow.dataset.autoplay === 'true';
  let interval;

  // Controllo che le slide abbiano immagini
  slides.forEach((slide, index) => {
    const img = slide.querySelector('img');
    if (!img) {
      console.warn(`CaSlide ${index + 1} does not contain an image`);
      slide.style.display = 'none'; // Nascondi slide senza immagini
    } else {
      slide.style.display = 'block';
      console.log(`CaSlide ${index + 1} image loaded: ${img.src}`);
    }
  });

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
      dots.forEach((dot, j) => dot.classList.toggle('ca-slider-counter__link--active', j === index));
      if (animationType === 'parallax') {
        slide.style.transform = i === index ? 'translateX(0) scale(1)' : `translateX(${(i - index) * 100}%) scale(0.9)`;
        slide.style.opacity = i === index ? '1' : '0.5';
      } else if (animationType === 'flip') {
        slide.style.transform = i === index ? 'rotateY(0deg)' : `rotateY(${i > index ? 90 : -90}deg)`;
        slide.style.opacity = i === index ? '1' : '0';
      } else if (animationType === 'skew') {
        slide.style.transform = i === index ? 'skew(0deg)' : `skew(${i > index ? 20 : -20}deg)`;
        slide.style.opacity = i === index ? '1' : '0';
      }
    });
    console.log(`Showing CaSlide ${index + 1}`);
  }

  function startAutoplay() {
    stopAutoplay(); // Evita duplicati
    interval = setInterval(() => {
      currentSlide = (currentSlide === slides.length - 1) ? 0 : currentSlide + 1;
      showSlide(currentSlide);
    }, speed);
    console.log('Autoplay started');
  }

  function stopAutoplay() {
    clearInterval(interval);
    console.log('Autoplay stopped');
  }

  // Inizializza la prima slide
  if (slides.length > 0) {
    showSlide(currentSlide);
    if (isPlaying) startAutoplay();
  } else {
    console.error('No CaSlides found in the slideshow');
  }

  // Event listener per i bottoni
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      currentSlide = (currentSlide === 0) ? slides.length - 1 : currentSlide - 1;
      showSlide(currentSlide);
      if (isPlaying) startAutoplay(); // Riavvia l'autoplay
      console.log('Previous button clicked');
    });
  } else {
    console.error('Previous button not found');
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      currentSlide = (currentSlide === slides.length - 1) ? 0 : currentSlide + 1;
      showSlide(currentSlide);
      if (isPlaying) startAutoplay(); // Riavvia l'autoplay
      console.log('Next button clicked');
    });
  } else {
    console.error('Next button not found');
  }

  if (dots) {
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        currentSlide = i;
        showSlide(currentSlide);
        if (isPlaying) startAutoplay(); // Riavvia l'autoplay
        console.log(`Dot ${i + 1} clicked`);
      });
    });
  } else {
    console.error('Dots not found');
  }
});